import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { defer, Observable, shareReplay } from 'rxjs';

import { UsheruApi } from '@usheru-hff/shared/data-access-backend';

import { GeoLocation } from './model/geoLocation';

@Injectable({
  providedIn: 'root'
})
export class GeoLocationService {
  private readonly httpService = inject(HttpClient);
  private readonly usheruApi = inject(UsheruApi);

  private readonly headers = this.usheruApi.getStandardHeader();

  private currentLocation$ = defer(() =>
    this.httpService.get<GeoLocation>('https://geo.usheru.com/api/ip-address')
  ).pipe(shareReplay(1));

  getCurrentLocation(): Observable<GeoLocation> {
    return this.currentLocation$;
  }
}
